// extracted by mini-css-extract-plugin
export default {"contentWrapper":"styles_contentWrapper__4k8p7","listWrapper":"styles_listWrapper__X21Ex"};